import request from '@/utils/request'

// 0501获取吉品列表
export function queryGoodsList (data) {
  return request({
    url: '/shop/goods/list',
    method: 'post',
    data
  })
}

// 0502获取吉品详情
export function queryGoodsDetail (data) {
  return request({
    url: '/shop/goods/detail',
    method: 'post',
    data
  })
}
// 0503购买商品
export function buyGoods (data) {
  return request({
    url: '/shop/goods/buy',
    method: 'post',
    data
  })
}

// 0504获取收货地址
export function queryAddress (data) {
  return request({
    url: '/shop/user/address',
    method: 'post',
    data
  })
}

// 0505添加和修改收货地址
export function updateAddress (data) {
  return request({
    url: '/shop/user/address/update',
    method: 'post',
    data
  })
}

// 0506获取用户积分收支事件列表
export function queryUserScore (data) {
  return request({
    url: '/shop/user/score',
    method: 'post',
    data
  })
}

// 0507获取商城积分列表
export function queryShopScore (data) {
  return request({
    url: '/shop/score/list',
    method: 'post',
    data
  })
}

// 0518 获取积分规则
export function queryShopRule (data) {
  return request({
    url: '/shop/rule',
    method: 'post',
    data
  })
}
